module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-100.34a6c424.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-100.png
// module id = 3285
// module chunks = 11